import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Container, Row, FormFeedback, Col, Modal, ModalHeader, ModalBody, ModalFooter, Table, Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import axios from 'axios';
import swal from 'sweetalert';


import { withRouter, Link } from 'react-router-dom';


// users
import user4 from '../assets/images/users/user-4.jpg';

import backend_url from "../routes/API_URL";
import Loader from "./Loader";

const API_URL = backend_url['api_url'];

class ProfileMenu extends Component {

	constructor(props) {
		super(props);
		this.state = {
			menu: false,
			modalVisible: false,
			formData: {
				user_password: '',
				user_password_confirm: '',
				email_id: sessionStorage.getItem("umail") || '',
				id: sessionStorage.getItem("uid") || '',
				bearer_auth: sessionStorage.getItem('token') || ''
			},
			validation: {
				passwordValid: false,
				passwordMatch: false,
				passwordTouched: false,
				confirmTouched: false,
				UpwordState: null,
				UpwordConfirmState: null
			},
			uiState: {
				is_loading: false,
				showPassword: false,
				showConfirmPassword: false
			},
			passwordStrength: {
				score: 0,
				hasMinLength: false,
				hasUppercase: false,
				hasLowercase: false,
				hasNumber: false,
				hasSpecialChar: false
			},
			sector: sessionStorage.getItem("sector")
		};
		this.toggle = this.toggle.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.updatePassword = this.updatePassword.bind(this);
		this.switchSector = this.switchSector.bind(this);
		this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
		this.validatePassword = this.validatePassword.bind(this);
		this.validatePasswordMatch = this.validatePasswordMatch.bind(this);
		this.getStrengthColor = this.getStrengthColor.bind(this);
		this.getStrengthLabel = this.getStrengthLabel.bind(this);
		this.clearForm = this.clearForm.bind(this);
	}

	toggle() {
		this.setState(prevState => ({
			menu: !prevState.menu,
			sector: sessionStorage.getItem("sector")
		}));
	}

	toggleModal() {
		if (!this.state.modalVisible) {
			// Reset form when opening modal
			this.clearForm();
		}
		this.setState(prevState => ({
			modalVisible: !prevState.modalVisible
		}));
	}

	togglePasswordVisibility(field) {
		this.setState(prevState => ({
			uiState: {
				...prevState.uiState,
				[field === 'password' ? 'showPassword' : 'showConfirmPassword']: 
					!prevState.uiState[field === 'password' ? 'showPassword' : 'showConfirmPassword']
			}
		}));
	}

	switchSector() {
		sessionStorage.setItem("sector", sessionStorage.getItem("sector") == 1 ? 2 : 1);
		window.dispatchEvent(new Event('sectorChanged'));
		this.setState({ sector: sessionStorage.getItem("sector") });
		// reload state
		this.props.history.push('/dashboard');

		window.location.href = "/dashboard";
	}

	//Validate password
	IsAlphaNumeric = (f_string) => {
		const expression = /(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#.,;~%?!@$%^&*-]).{8,}$/;
		return f_string.match(expression);
	}

	validatePassword(password) {
		const checks = {
			hasMinLength: password.length >= 8,
			hasUppercase: /[A-Z]/.test(password),
			hasLowercase: /[a-z]/.test(password),
			hasNumber: /[0-9]/.test(password),
			hasSpecialChar: /[#.,;~%?!@$%^&*-]/.test(password)
		};
		
		const score = Object.values(checks).filter(Boolean).length;
		const isValid = score >= 4 && checks.hasMinLength;
		
		this.setState(prevState => ({
			passwordStrength: checks,
			validation: {
				...prevState.validation,
				passwordValid: isValid,
				UpwordState: isValid ? 'has-success' : 'has-danger',
				passwordTouched: true
			}
		}));
	}

	validatePasswordMatch(confirmPassword) {
		const match = this.state.formData.user_password === confirmPassword;
		this.setState(prevState => ({
			validation: {
				...prevState.validation,
				passwordMatch: match,
				UpwordConfirmState: match ? 'has-success' : 'has-danger',
				confirmTouched: true
			}
		}));
	}

	handleInputChange(e) {
		const { name, value } = e.target;
		
		this.setState(prevState => ({
			formData: {
				...prevState.formData,
				[name]: value
			}
		}), () => {
			if (name === 'user_password') {
				this.validatePassword(value);
				// Re-validate confirm password if it has value
				if (this.state.formData.user_password_confirm) {
					this.validatePasswordMatch(this.state.formData.user_password_confirm);
				}
			} else if (name === 'user_password_confirm') {
				this.validatePasswordMatch(value);
			}
		});
	}

	clearForm() {
		this.setState({
			formData: {
				...this.state.formData,
				user_password: '',
				user_password_confirm: ''
			},
			validation: {
				passwordValid: false,
				passwordMatch: false,
				passwordTouched: false,
				confirmTouched: false,
				UpwordState: null,
				UpwordConfirmState: null
			},
			passwordStrength: {
				score: 0,
				hasMinLength: false,
				hasUppercase: false,
				hasLowercase: false,
				hasNumber: false,
				hasSpecialChar: false
			}
		});
	}

	validateForm() {
		const { formData, validation } = this.state;
		
		if (!formData.user_password) return false;
		if (!validation.passwordValid) return false;
		if (!formData.user_password_confirm) return false;
		if (!validation.passwordMatch) return false;
		
		return true;
	}

	//updating password
	updatePassword(event) {
		event.preventDefault()

		if (!this.validateForm()) {
			return;
		}

		const id = this.state.formData.id;

		const payload = {
			email_id: this.state.formData.email_id,
			user_password: this.state.formData.user_password,
		}

		this.setState(prevState => ({
			uiState: {
				...prevState.uiState,
				is_loading: true
			}
		}));

		axios.patch(API_URL + `/users/reset_password/${id}`, payload, { 
			headers: { 
				"Authorization": `Bearer ${this.state.formData.bearer_auth}` 
			} 
		})
		.then(response => {
			this.setState(prevState => ({
				modalVisible: false,
				uiState: {
					...prevState.uiState,
					is_loading: false
				}
			}));
			
			swal({
				title: "Success!",
				text: "Password updated successfully! For security reasons, you'll be logged out. Please use your new password to log in.",
				icon: "success",
				button: "OK",
			})
			.then(() => {
				sessionStorage.clear();
				window.location.href = '/login';
			});
		})
		.catch(error => {
			this.setState(prevState => ({
				modalVisible: false,
				uiState: {
					...prevState.uiState,
					is_loading: false
				}
			}));
			
			let errorMessage = '';
			
			if (error.response) {
				if (error.response.status === 404) {
					errorMessage = 'User not found. Please try again.';
				} else if (error.response.status === 401) {
					errorMessage = 'Unauthorized. Your session may have expired.';
				} else if (error.response.data && error.response.data.message) {
					errorMessage = error.response.data.message;
				} else {
					errorMessage = 'Failed to update password.';
				}
			} else if (error.request) {
				errorMessage = 'No response from server. Please check your connection.';
			} else {
				errorMessage = error.message;
			}

			swal({
				title: "Error",
				text: errorMessage + " Contact the system administrator for more.",
				icon: "error",
				button: "OK",
			})
			.then(() => {
				this.setState({ modalVisible: true });
			});
		});
	}

	// Get password strength color
	getStrengthColor() {
		const { passwordStrength } = this.state;
		const score = Object.values(passwordStrength).filter(Boolean).length;
		if (score === 0) return 'secondary';
		if (score <= 2) return 'danger';
		if (score <= 3) return 'warning';
		return 'success';
	}

	// Get password strength label
	getStrengthLabel() {
		const { passwordStrength } = this.state;
		const score = Object.values(passwordStrength).filter(Boolean).length;
		if (score === 0) return 'No password';
		if (score <= 2) return 'Weak';
		if (score <= 3) return 'Fair';
		if (score === 4) return 'Good';
		return 'Strong';
	}

	render() {
		const user = sessionStorage.getItem("uname");
		const salute = sessionStorage.getItem("sal");
		const fname = sessionStorage.getItem("fname");
		const lname = sessionStorage.getItem("lname");
		const role = sessionStorage.getItem("urole");
		const override_sector = sessionStorage.getItem("override_sector") || 0;
		const sector = this.state.sector == 1 ? "Primary" : "Secondary";
		const full_name = `${salute || ''} ${fname || ''} ${lname || ''}`.trim();
		
		const { formData, validation, uiState, passwordStrength } = this.state;

		return (
			<React.Fragment>
				<Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block" >
					<DropdownToggle className="btn header-item waves-effect" id="page-header-user-dropdown" tag="button">
						<i className="mdi mdi-account-circle font-size-17 align-middle mr-1 text-white"></i>
					</DropdownToggle>
					<DropdownMenu right>
						<div className="dropdown-divider"></div>
						<Link
							onClick={(e)=>{e.preventDefault();}}
							to='#'
							className="dropdown-item">
							<i className="mdi mdi-account-circle font-size-17 align-middle mr-1"></i>
							<i>{user}</i>
						</Link>
						<div className="dropdown-divider"></div>
						<Link
							onClick={(e)=>{e.preventDefault();}}
							to='#'
							className="dropdown-item">
							<span>{`${role} (${sector})`}</span>
						</Link>
						<div className="dropdown-divider"></div>
						<Link
							to='#'
							onClick={(e) => {
								e.preventDefault();
								this.toggleModal();
							}}
							className="dropdown-item">
							<i className="mdi mdi-key font-size-17 align-middle mr-1"></i>
							<i>Change Password</i>
						</Link>
						{ override_sector == 1 &&
							( <Link
								onClick={() => this.switchSector()}
								to='#'
								className="dropdown-item">
								<i className="mdi mdi-switch font-size-17 align-middle mr-1"></i>
								<i>Switch Sector</i>
							</Link> )
						}
						<div className="dropdown-divider"></div>
						<Link
							to='/logout'
							className="dropdown-item">
							<i className="mdi mdi-logout font-size-17 align-middle mr-1"></i>
							<span>Logout</span>
						</Link>
					</DropdownMenu>
				</Dropdown>

				{/* Enhanced Password Reset Modal */}
				<Modal isOpen={this.state.modalVisible} toggle={this.toggleModal} size="lg" className="password-reset-modal">
					<Form onSubmit={this.updatePassword}>
						<ModalHeader toggle={this.toggleModal} className="bg-danger text-white">
							<center className="w-100">
								<strong>PASSWORD RESET FORM FOR {full_name.toUpperCase()}</strong>
							</center>
						</ModalHeader>
						
						<ModalBody>
							{uiState.is_loading && <Loader />}
							
							{/* User Info Display */}
							<div className="text-center mb-4 p-3 bg-light rounded">
								<h6 className="text-muted mb-2">User: <span className="text-danger font-weight-bold">{full_name || user}</span></h6>
								<p className="mb-0 small">Email: {formData.email_id}</p>
							</div>
							
							{/* Email (readonly) */}
							<FormGroup>
								<Row>
									<Col xs={12} md={3}>
										<Label for="email_id" className="font-weight-bold">Email Address</Label>
									</Col>
									<Col xs={12} md={9}>
										<Input
											type="email"
											id="email_id"
											name="email_id"
											value={formData.email_id}
											readOnly
											className="bg-light"
										/>
										<small className="text-muted">
											This is the email associated with your account
										</small>
									</Col>
								</Row>
							</FormGroup>
							
							{/* New Password */}
							<FormGroup>
								<Row>
									<Col xs={12} md={3}>
										<Label for="user_password" className="font-weight-bold">New Password</Label>
									</Col>
									<Col xs={12} md={9}>
										<div className="d-flex">
											<Input
												type={uiState.showPassword ? "text" : "password"}
												id="user_password"
												name="user_password"
												value={formData.user_password}
												onChange={this.handleInputChange}
												invalid={validation.UpwordState === 'has-danger'}
												valid={validation.UpwordState === 'has-success'}
												placeholder="Enter new password"
												required
												style={{ flex: 1 }}
											/>
											<Button
												type="button"
												color="secondary"
												onClick={() => this.togglePasswordVisibility('password')}
												style={{ marginLeft: '5px' }}
											>
												<i className={`fas ${uiState.showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
											</Button>
										</div>
										
										{/* Password strength meter */}
										{formData.user_password && (
											<div className="mt-2">
												<div className="d-flex justify-content-between mb-1">
													<small>Password Strength:</small>
													<small className={`text-${this.getStrengthColor()}`}>
														<strong>{this.getStrengthLabel()}</strong>
													</small>
												</div>
												<div className="progress" style={{ height: '5px' }}>
													<div
														className={`progress-bar bg-${this.getStrengthColor()}`}
														role="progressbar"
														style={{ width: `${(Object.values(passwordStrength).filter(Boolean).length / 5) * 100}%` }}
													></div>
												</div>
											</div>
										)}
										
										{/* Password requirements checklist */}
										<div className="mt-2 small">
											<div className="row">
												<div className="col-6">
													<div className={`d-flex align-items-center mb-1 ${passwordStrength.hasMinLength ? 'text-success' : 'text-muted'}`}>
														<i className={`fas ${passwordStrength.hasMinLength ? 'fa-check-circle' : 'fa-circle'} me-1`}></i>
														<span>8+ characters</span>
													</div>
													<div className={`d-flex align-items-center mb-1 ${passwordStrength.hasUppercase ? 'text-success' : 'text-muted'}`}>
														<i className={`fas ${passwordStrength.hasUppercase ? 'fa-check-circle' : 'fa-circle'} me-1`}></i>
														<span>Uppercase letter</span>
													</div>
													<div className={`d-flex align-items-center mb-1 ${passwordStrength.hasLowercase ? 'text-success' : 'text-muted'}`}>
														<i className={`fas ${passwordStrength.hasLowercase ? 'fa-check-circle' : 'fa-circle'} me-1`}></i>
														<span>Lowercase letter</span>
													</div>
												</div>
												<div className="col-6">
													<div className={`d-flex align-items-center mb-1 ${passwordStrength.hasNumber ? 'text-success' : 'text-muted'}`}>
														<i className={`fas ${passwordStrength.hasNumber ? 'fa-check-circle' : 'fa-circle'} me-1`}></i>
														<span>Number</span>
													</div>
													<div className={`d-flex align-items-center mb-1 ${passwordStrength.hasSpecialChar ? 'text-success' : 'text-muted'}`}>
														<i className={`fas ${passwordStrength.hasSpecialChar ? 'fa-check-circle' : 'fa-circle'} me-1`}></i>
														<span>Special character (#.,;~%?!@$%^&*-)</span>
													</div>
												</div>
											</div>
										</div>
										
										<FormFeedback invalid>
											The password must be at least 8 characters long and contain uppercase, lowercase, numbers, and special characters.
										</FormFeedback>
									</Col>
								</Row>
							</FormGroup>
							
							{/* Confirm Password */}
							<FormGroup>
								<Row>
									<Col xs={12} md={3}>
										<Label for="user_password_confirm" className="font-weight-bold">Confirm Password</Label>
									</Col>
									<Col xs={12} md={9}>
										<div className="d-flex">
											<Input
												type={uiState.showConfirmPassword ? "text" : "password"}
												id="user_password_confirm"
												name="user_password_confirm"
												value={formData.user_password_confirm}
												onChange={this.handleInputChange}
												invalid={validation.UpwordConfirmState === 'has-danger'}
												valid={validation.UpwordConfirmState === 'has-success'}
												placeholder="Re-enter password"
												required
												style={{ flex: 1 }}
											/>
											<Button
												type="button"
												color="secondary"
												onClick={() => this.togglePasswordVisibility('confirm')}
												style={{ marginLeft: '5px' }}
											>
												<i className={`fas ${uiState.showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
											</Button>
										</div>
										
										{validation.confirmTouched && !validation.passwordMatch && (
											<div className="text-danger small mt-1">
												<i className="fas fa-times-circle me-1"></i> Passwords do not match
											</div>
										)}
										
										{validation.passwordMatch && formData.user_password_confirm && (
											<div className="text-success small mt-1">
												<i className="fas fa-check-circle me-1"></i> Passwords match!
											</div>
										)}
										
										<FormFeedback invalid>
											Password Mismatched. Retry...
										</FormFeedback>
									</Col>
								</Row>
							</FormGroup>
						</ModalBody>
						
						<ModalFooter>
							<Button 
								type="submit" 
								color="success"
								disabled={uiState.is_loading || !validation.passwordValid || !validation.passwordMatch}
							>
								{uiState.is_loading ? (
									<>
										<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
										Resetting...
									</>
								) : (
									'Reset Password'
								)}
							</Button>
							<Button 
								type="button" 
								color="danger"
								onClick={this.clearForm}
							>
								Clear
							</Button>
							<Button color="secondary" onClick={this.toggleModal}>
								Cancel
							</Button>
						</ModalFooter>
					</Form>
				</Modal>
			</React.Fragment>
		);
	}
}

export default withRouter(ProfileMenu);